<template>
  <div v-if="isLoaded">
    <!--IF設定-->
    <v-card v-permission.config v-if="showIfStatus" variant="outlined">
      <v-card-title class="font-weight-bold">IF設定</v-card-title>
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form novalidate @submit.stop.prevent="handleSubmit(execIfState)">
          <v-card-text class="pt-0">
            <v-row>
              <v-col>
                <validation-provider
                  v-model="form.ifState.ifStatus"
                  name="ifStatus"
                  label="IF設定"
                  :rules="{ is_not: ifStatus === null ? 'SHUTDOWN' : ifStatus }"
                  v-slot="{ componentField, errorMessage }"
                  class="v-col"
                >
                  <v-radio-group
                    v-bind="componentField"
                    :error-messages="errorMessage"
                    inline
                  >
                    <v-radio
                      :label="$filter.enumTo('SHUTDOWN', 'cloudVn_ifStatus')"
                      value="SHUTDOWN"
                    />
                    <v-radio
                      :label="$filter.enumTo('NO_SHUTDOWN', 'cloudVn_ifStatus')"
                      value="NO_SHUTDOWN"
                    />
                  </v-radio-group>
                </validation-provider>
              </v-col>
              <v-col>
                <div class="d-flex justify-end">
                  <v-btn color="primary" type="submit">設定反映</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
      </validation-observer>
    </v-card>
    <!--参照コマンド-->
    <v-card v-permission.config class="mt-3" variant="outlined">
      <v-card-title class="font-weight-bold">参照コマンド</v-card-title>
      <v-card-text class="pt-0">
        <v-row>
          <v-col cols="10">
            <v-radio-group v-model="form.reference.commandType" inline>
              <v-radio
                v-for="(reference, index) in references"
                :key="`${reference.text + index}`"
                :label="reference.text"
                :value="reference.value"
              />
            </v-radio-group>
          </v-col>
          <v-col cols="2">
            <div class="d-flex justify-end">
              <v-btn color="primary" @click="execReference">実行</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--疎通確認コマンド-->
    <v-card
      v-permission.config
      v-if="isShowConnectivity"
      class="mt-3"
      variant="outlined"
    >
      <v-card-title class="font-weight-bold">疎通確認コマンド</v-card-title>
      <validation-observer v-slot="{ handleSubmit }" as="div">
        <v-form
          novalidate
          @submit.stop.prevent="handleSubmit(execConnectivity)"
        >
          <v-card-text class="pt-0">
            <v-row>
              <v-col>
                <validation-provider
                  name="commandType"
                  v-model="form.connectivity.commandType"
                  label="疎通確認コマンド"
                  :rules="{ required: true }"
                  v-slot="{ componentField, errorMessage, meta }"
                >
                  <app-select
                    :items="[
                      { value: 'PING', title: 'ping' },
                      { value: 'TRACEROUTE', title: 'traceroute' },
                    ]"
                    v-bind="componentField"
                    :error-messages="errorMessage"
                    :field-meta="meta"
                  >
                  </app-select>
                </validation-provider>
              </v-col>
              <v-col>
                <validation-provider
                  name="ipAddress"
                  v-model="form.connectivity.ipAddress"
                  label="引数"
                  :rules="{ required: true, is_ipv4: true }"
                  v-slot="{ componentField, errorMessage, meta }"
                >
                  <app-form-input
                    v-bind="componentField"
                    :error-messages="errorMessage"
                    :field-meta="meta"
                    :placeholder="$filter.message('placeholder_ip_address')"
                  >
                  </app-form-input>
                </validation-provider>
              </v-col>
              <v-col>
                <div class="d-flex justify-end">
                  <v-btn color="primary" type="submit">実行</v-btn>
                </div>
              </v-col>
            </v-row>
          </v-card-text></v-form
        >
      </validation-observer>
    </v-card>
    <!--クラウド回線情報取得-->
    <v-card
      v-permission.config
      v-if="lineCategory === 'CLOUD' && kcpsVersion !== 'V1'"
      class="mt-3"
      variant="outlined"
    >
      <v-card-title class="font-weight-bold">クラウド回線情報取得</v-card-title>
      <v-card-text class="pt-0">
        <v-row>
          <v-col>
            <div class="d-flex justify-end">
              <v-btn color="primary" @click="execCloudInformation">実行</v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--SASEゲートウェイ回線情報取得-->
    <v-card
      v-permission.config
      v-if="lineCategory === 'SASE_GATEWAY'"
      class="mt-3"
      variant="outlined"
    >
      <v-card-title class="font-weight-bold"
        >SASEゲートウェイ回線情報取得</v-card-title
      >
      <v-card-text class="pt-0">
        <v-row>
          <v-col>
            <div class="d-flex justify-end">
              <v-btn color="primary" @click="execSaseGatewayInformation"
                >実行</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!--KCPSプライベートアクセスルーター再起動-->
    <v-card
      v-permission.config
      v-if="lineCategory === 'CLOUD' && kcpsVersion === 'V2'"
      class="mt-3"
      variant="outlined"
    >
      <v-card-title class="font-weight-bold"
        >KCPSプライベートアクセスルーター再起動</v-card-title
      >
      <v-card-text class="pt-0">
        <v-row>
          <v-col>
            <div class="d-flex justify-end">
              <v-btn color="primary" @click="execKcpsPrivateAccessRouterRestart"
                >実行</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <!-- コマンド実行結果一覧 -->
    <div class="mt-3">
      <v-alert v-if="!!alertMsg" :text="alertMsg" class="mb-3" />
      <app-table
        primary-key="entryNumber"
        :fields="commandResults.fields"
        :items="commandResults.items"
        :selectable="true"
        :per-page="-1"
        :tr-class="() => undefined"
        v-model="commandResults.selected"
      >
        <template #cell(_selected)="{ item }">
          <v-checkbox-btn
            :value="item"
            v-model="commandResults.selected"
            :disabled="item.commandStatus === 'EXECUTION'"
            @click.stop
          />
        </template>
        <template #cell(createDateTime)="{ value }">
          {{ $filter.datetime(value, { s: true }) }}
        </template>
        <template #cell(commandType)="{ value }">
          {{ $filter.enumTo(value, "commandInfo_commandType") }}
        </template>
        <template #cell(ipAddress)="{ value }">
          {{ $filter.emptyTo(value, "-") }}
        </template>
        <template #cell(commandStatus)="{ value }">
          {{ $filter.enumTo(value, "commandInfo_commandStatus") }}
        </template>
        <template #cell(endDateTime)="{ value }">
          {{ $filter.datetime(value, { s: true }) }}
        </template>
      </app-table>
      <div class="d-flex justify-end ga-2 mt-4">
        <v-btn color="primary" @click="loadCommandResults">更新</v-btn>
        <v-btn color="primary" @click="showResult">結果表示</v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import type { PropType } from "vue";
import type {
  CommandInfo,
  LineCategory,
  PostCloudInformationRequest,
  PostSaseGatewayInformationRequest,
  PostKcpsPrivateAccessRouterRestartRequest,
  PostConnectivityRequest,
  PostReferenceRequest,
  PutIfStateRequest,
} from "@/apis/NwOperationToolApi";
import OperationCmdReference from "@/modals/common/OperationCmdReference.vue";
import IFModify from "@/modals/common/IFModify.vue";
import KcpsPrivateAccessRouterRestartModify from "@/modals/common/KcpsPrivateAccessRouterRestartModify.vue";
import type { VNConnectDetail } from "@/apis/VNConnectApi";
import { SystemError } from "@/error/errors";
import type { AppTableHeader } from "@/components/AppTable.vue";

/** コマンド実行時のemitイベント */
export type EventEmit =
  | "IF_STATE"
  | "REFERENCE"
  | "CONNECTIVITY"
  | "CLOUD_INFORMATION"
  | "SASE_GATEWAY_INFORMATION"
  | "REBOOT";

/** 運用ツールコマンドタブ */
export default defineComponent({
  name: "OperationCommand",
  props: {
    /** 参照回線種別 */
    lineCategory: {
      type: String as PropType<LineCategory>,
      required: true,
    },
    /**
     * W番号（E番号）.
     * 参照回線種別がVNコネクト、VNL2L3、マルチクラウドの場合は必須
     */
    wnumber: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
    /**
     * X番号.
     * 参照回線種別がACの場合は必須
     */
    xnumber: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
    /**
     * true: IF設定表示（デフォルト）
     * VNコネクトがV番連携の場合やクラウドのMSの場合などに非表示
     */
    showIfStatus: {
      type: Boolean as PropType<boolean>,
      default: true,
    },
    /** IF状態 */
    ifStatus: {
      type: String as PropType<"SHUTDOWN" | "NO_SHUTDOWN" | null>,
      default: null,
    },
    /**
     * 排他制御情報.
     * IF状態変更/参照コマンド/疎通確認コマンド/クラウド情報取得の場合必須
     */
    keyId: {
      type: String as PropType<string>,
      required: true,
    },
    /** VNコネクト詳細. 参照回線種別がVNの場合は必須 */
    vnConnectDetail: {
      type: [Object, undefined] as PropType<
        Pick<VNConnectDetail, "vnType" | "l3"> | undefined
      >,
      default: undefined,
    },
    /** L2L3の種別. 参照回線種別がL2L3の場合は必須 */
    routingType: {
      type: String as PropType<"STATIC" | "OSPF" | "BGP4" | undefined>,
      default: undefined,
    },
    /**
     * KCPSバージョン.
     * 'V1': クラウド回線情報取得・KCPSプライベートアクセスルーター再起動を非表示
     * 'V2': KCPSプライベートアクセスルーター再起動を表示
     * undefined: 非KCPS回線
     */
    kcpsVersion: {
      type: String as PropType<"V1" | "V2" | undefined>,
      default: undefined,
    },
    /**
     * クラウド回線SEQ.
     * kcpsVersion が 'V2' の場合（VNコネクト再起動）に必須
     */
    cloudLineSeq: {
      type: String as PropType<string | undefined>,
      default: undefined,
    },
  },
  data() {
    return {
      form: {
        ifState: {
          wnumber: this.wnumber,
          xnumber: this.xnumber,
          ifStatus: this.ifStatus ?? "SHUTDOWN",
          ifStateKeyId: this.keyId,
        } as PutIfStateRequest,
        reference: {
          wnumber: this.wnumber,
          xnumber: this.xnumber,
          referenceCommandKeyId: this.keyId,
        } as PostReferenceRequest,
        connectivity: {
          wnumber: this.wnumber,
          xnumber: this.xnumber,
          commandType: "PING",
          ipAddress: "",
          connectTestKeyId: this.keyId,
        } as PostConnectivityRequest,
        cloudinformation: {
          wnumber: this.wnumber,
          cloudLineInfomationKeyId: this.keyId,
        } as PostCloudInformationRequest,
        saseGatewayInformation: {
          wnumber: this.wnumber,
          saseGatewayInformationKeyId: this.keyId,
        } as PostSaseGatewayInformationRequest,
        kcpsPrivateAccessRouterRestart: {
          wnumber: this.wnumber,
          kcpsPrivateAccessRouterRestartKeyId: this.keyId,
        } as PostKcpsPrivateAccessRouterRestartRequest,
      },
      commandResults: {
        fields: [
          {
            key: "createDateTime",
            title: "コマンド登録日時",
            align: "start",
            width: " 190px",
          },
          { key: "commandType", title: "コマンド", align: "start" },
          {
            key: "ipAddress",
            title: "指定アドレス",
            align: "start",
            width: "140px",
          },
          {
            key: "commandStatus",
            title: "ステータス",
            align: "start",
            width: "110px",
          },
          {
            key: "endDateTime",
            title: "コマンド応答日時",
            align: "start",
            width: "190px",
          },
        ] as AppTableHeader<CommandInfo>[],
        items: [] as CommandInfo[],
        selected: [] as CommandInfo[],
      },
      alertMsg: null as string | null,
      isLoaded: false,
    };
  },
  watch: {
    keyId(value) {
      this.form.ifState.ifStateKeyId = value;
      this.form.reference.referenceCommandKeyId = value;
      this.form.connectivity.connectTestKeyId = value;
      this.form.cloudinformation.cloudLineInfomationKeyId = value;
      this.form.saseGatewayInformation.saseGatewayInformationKeyId = value;
      this.form.kcpsPrivateAccessRouterRestart.kcpsPrivateAccessRouterRestartKeyId =
        value;
    },
  },
  computed: {
    /** 参照コマンド一覧 */
    references(): {
      value: PostReferenceRequest["commandType"];
      text: string;
    }[] {
      const values = ((): PostReferenceRequest["commandType"][] => {
        switch (this.lineCategory) {
          // IPSec回線
          case "AC":
            return ["GATEWAY", "SA"];
          // VNコネクト（L2, L3-Static, L3-BGP4）
          case "VN":
            if (this.vnConnectDetail!.vnType === "L2") {
              // L2
              return ["MAC"];
            } else {
              if (this.vnConnectDetail!.l3?.bgp4) {
                // L3 BGP4
                return ["BGP", "ROUTE", "ARP"];
              } else {
                // L3 Static
                return ["ROUTE", "ARP"];
              }
            }
          case "L2L3":
            switch (this.routingType!) {
              case "STATIC":
                return ["ROUTE", "ARP"];
              case "OSPF":
                return ["OSPF", "ROUTE", "ARP"];
              case "BGP4":
                return ["BGP", "ROUTE", "ARP"];
            }
            break;
          // マルチクラウド
          case "CLOUD":
            return ["BGP", "ROUTE", "ARP"];
          // SASEゲートウェイ
          case "SASE_GATEWAY":
            return ["BGP", "ROUTE", "ARP"];
        }
      })();

      return values.map((v) => {
        switch (v) {
          case "GATEWAY":
            return { value: v, text: "ゲートウェイ経路情報参照" };
          case "SA":
            return { value: v, text: "SA状態参照" };
          case "MAC":
            return { value: v, text: "MACテーブル参照" };
          case "BGP":
            return { value: v, text: "BGPネイバー参照" };
          case "ROUTE":
            return { value: v, text: "経路情報参照" };
          case "ARP":
            return { value: v, text: "ARP参照" };
          case "OSPF":
            return { value: v, text: "OSPFネイバー参照" };
        }
      });
    },
    /** true: 疎通確認表示, false: 非表示 */
    isShowConnectivity(): boolean {
      // VNコネクトでL2の場合は非表示
      switch (this.lineCategory) {
        case "VN":
          return this.vnConnectDetail!.vnType !== "L2";
        case "SASE_GATEWAY":
          return true;
        default:
          return true;
      }
    },
  },
  created() {
    // propsのバリデーション
    if (this.lineCategory === "AC" && this.xnumber === undefined) {
      throw new SystemError("required xnumber when AC");
    }
    if (this.lineCategory !== "AC" && this.wnumber === undefined) {
      throw new SystemError("required wnumber when not AC");
    }
    if (this.lineCategory === "VN" && this.vnConnectDetail === undefined) {
      throw new SystemError("required vnConnectDetail when VN");
    }
    if (this.lineCategory === "L2L3" && this.routingType === undefined) {
      throw new SystemError("required routingType when L2L3");
    }

    // 参照コマンドの初期値を最初の選択肢に設定
    this.form.reference.commandType = this.references[0].value;
  },
  async mounted() {
    await this.loadCommandResults();
    this.isLoaded = true;
  },
  methods: {
    /** コマンド実行結果一覧 */
    async loadCommandResults() {
      this.alertMsg = null;
      if (this.lineCategory === "AC") {
        this.commandResults.items =
          await this.$api.nwOperationTool.getCommandResultsAC(
            this.lineCategory,
            this.xnumber!
          );
      } else {
        this.commandResults.items =
          await this.$api.nwOperationTool.getCommandResultsVN(
            this.lineCategory,
            this.wnumber!
          );
      }
    },
    /** Shutdown/No Shutdown設定反映 */
    async execIfState() {
      this.alertMsg = null;
      await this.$modal.show(IFModify, {
        lineCategory: this.lineCategory,
        number: this.lineCategory === "AC" ? this.xnumber : this.wnumber,
        ifStatus: this.form.ifState.ifStatus,
      });
      await this.$api.nwOperationTool.putIfStatus(
        this.lineCategory,
        this.form.ifState
      );
      this.$emit("executed", "IF_STATE");
    },
    /** 参照コマンド実行 */
    async execReference() {
      this.alertMsg = null;
      await this.$api.nwOperationTool.postReference(
        this.lineCategory,
        this.form.reference
      );
      this.$emit("executed", "REFERENCE");
      await this.loadCommandResults();
    },
    /** 疎通確認コマンド実行 */
    async execConnectivity() {
      this.alertMsg = null;
      await this.$api.nwOperationTool.postConnectivity(
        this.lineCategory,
        this.form.connectivity
      );
      this.$emit("executed", "CONNECTIVITY");
      await this.loadCommandResults();
    },
    /** クラウド回線情報取得実行 */
    async execCloudInformation() {
      this.alertMsg = null;
      await this.$api.nwOperationTool.postCloudInformation(
        this.form.cloudinformation
      );
      this.$emit("executed", "CLOUD_INFORMATION");
      await this.loadCommandResults();
    },
    /** SASEゲートウェイ回線情報取得実行 */
    async execSaseGatewayInformation() {
      this.alertMsg = null;
      await this.$api.nwOperationTool.postSaseGatewayInformation(
        this.form.saseGatewayInformation
      );
      this.$emit("executed", "SASE_GATEWAY_INFORMATION");
      await this.loadCommandResults();
    },
    /** KCPSプライベートアクセスルーター再起動実行 */
    async execKcpsPrivateAccessRouterRestart() {
      this.alertMsg = null;
      await this.$modal.show(KcpsPrivateAccessRouterRestartModify, {
        wnumber: this.wnumber!,
      });
      await this.$api.cloudVnKcps.rebootVnConnect(
        this.cloudLineSeq!,
        this.wnumber!,
        {
          cloudVnKcpsKeyId: this.keyId,
        }
      );
      this.$emit("executed", "REBOOT");
      await this.loadCommandResults();
    },
    /** 運用コマンド実行結果表示 */
    showResult() {
      if (this.commandResults.selected.length === 0) {
        this.alertMsg = this.$filter.message("no_select_data");
        return;
      } else {
        this.alertMsg = null;
      }
      this.$modal.show(OperationCmdReference, {
        lineCategory: this.lineCategory,
        number: this.lineCategory === "AC" ? this.xnumber : this.wnumber,
        entryNumbers: this.commandResults.selected.map((e) => e.entryNumber),
      });
    },
    /** エラーメッセージを初期化する(親画面から呼び出される) */
    async alertClear() {
      this.alertMsg = null;
    },
  },
});
</script>

<style scoped lang="scss">
.v-card-title {
  border-left: 0 !important;
  font-size: 1em;
}
.v-card {
  border-color: rgba(0, 0, 0, 0.125);
}
</style>
